module.exports = __webpack_public_path__ + "static/media/sign-note.5368acc4.svg";